import React, { ReactNode } from 'react';

const conditionalRenderingArray = <T extends ReactNode>(condition: boolean, els: T[]) => {
  return els.map(el => (
    condition ? el : React.Fragment
  ));
};

export default conditionalRenderingArray;